import React from "react";
import { navigate, useStaticQuery, graphql, Link } from "gatsby";
import EmailLink from "./EmailLink";
import CallPhoneLink from "./CallPhoneLink";


export default function Contact() {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      allStrapiResortWebsites {
        edges {
          node {
            company_logo {
              url
            }
            company_name
            domain_name
            phone_number
            company_address
            company_email
          }
        }
      }
    }
  `);
  const company = data.allStrapiResortWebsites.edges[0].node;
  return (
    <div>
      <section class="py-10 bg-blue-50 overflow-hidden pt-80 sm:pt-12">
        <div class="container mx-auto px-4">
          <div class="py-16 px-8 bg-white overflow-hidden border border-blue-100 rounded-3xl">
            <div class="max-w-7xl mx-auto">
              <div class="mb-10 md:max-w-md mx-auto text-center">
                <h3 class="font-heading mb-6 text-4xl md:text-5xl lg:text-6xl text-blue-900 font-black tracking-tight">
                  Stay connected
                </h3>
              </div>
              <div class="flex flex-wrap -m-4">
                <div class="w-full md:w-1/3 p-4">
                  <EmailLink emailAddress={company.company_email} subject="I have a question?">
                  <div class="p-10 text-center h-full bg-blue-100 rounded-3xl">
                    <div class="flex items-center justify-center mb-6 w-12 h-12 mx-auto bg-white rounded-xl">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6 text-blue-600"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H6.911a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661z"
                          fill=""
                        />
                      </svg>
                    </div>
                    <h4 class="font-heading mb-2 text-xl text-blue-900 font-black">
                      Send Email
                    </h4>

                    <p class="text-blue-500 font-bold -ml-16 md:-ml-8 lg:-ml-10 xl:-ml-0">
                      {company.company_email}
                    </p>
                  </div>
                  </EmailLink>
                </div>
                <div class="w-full md:w-1/3 p-4">
                  
                  <div class="p-10 text-center h-full bg-blue-100 rounded-3xl">
                    <CallPhoneLink phoneNumber={company.phone_number}>
                    <div class="flex items-center justify-center mb-6 w-12 h-12 mx-auto bg-white rounded-xl">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6 text-blue-600"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                          fill=""
                        />
                      </svg>
                    </div>
                    <h4 class="font-heading mb-2 text-xl text-blue-900 font-black">
                      Call Us
                    </h4>
                    <p class="text-blue-500 font-bold">
                      {company.phone_number}
                    </p>
                    </CallPhoneLink>
                  </div>
                </div>
                <div class="w-full md:w-1/3 p-4">
                  <div class="p-10 text-center h-full bg-blue-100 rounded-3xl">
                    <div class="flex items-center justify-center mb-6 w-12 h-12 mx-auto bg-white rounded-xl">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6 text-blue-600"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                          fill=""
                        />
                      </svg>
                    </div>
                    <h4 class="font-heading mb-2 text-xl text-blue-900 font-black">
                      Address
                    </h4>
                    <p class="text-blue-500 font-bold">
                      {company?.company_address.slice(0, 24)}
                    </p>
                    <p class="text-blue-500 font-bold">
                      {company?.company_address.slice(25, 50)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center mt-4 -mb-12">
            <h4 class="mb-4 text-xl md:text-2xl leading-tight font-bold pt-2 "> Upcoming Events</h4>
            <ul className="text-gray-500 sm:inline-flex">
              <li className="mx-2">
                <Link to="https://events.occc.net/" className="hover:underline text-gray-400">
                  Orlando
                </Link>
              </li>
              <li className="mx-2 my-2 sm:my-0">
                <Link to="https://conventioncalendar.com/LasVegas" className="hover:underline text-gray-400">
                  Las Vegas
                </Link>
              </li>
              <li className="mx-2">
                <Link to="https://conventioncalendar.com/Chicago" className="hover:underline text-gray-400">
                  Chicago
                </Link>
              </li>
              <li className="mx-2 my-2 sm:my-0">
                <Link to="https://www.oceancenter.com/events/calendar.stml"  className="hover:underline text-gray-400">
                  Daytona
                </Link>
              </li>
              
             
              
              
            </ul>
          </div>
          </div>
          
        </div>
      </section>
    </div>
  );
}
